import { makeGuidance } from 'hooks';

const routinesPermanentGuidance =
  'Routines are the building blocks of your ConOps, allowing for comprehensive and customizable modeling of flight software and other behavior of agents in Sedaro. Routines are used to construct programs, which are logically independent structures stemming from a single main routine. The main routine is always active and, based on its type, may select an active subroutine out of its subroutines.';

export const useGuidance = makeGuidance({
  _default: {
    heading: 'Routines',
    body: [
      {
        chunk: 'Set the properties of the Routine.',
      },
    ],
  },
  name: {
    heading: 'Routines - Name',
    body: [
      {
        chunk: 'Set the name of the Routine.',
      },
    ],
  },
});

const routinesSegmentGuidance = {
  heading: 'Routines',
  body: [
    {
      chunk: routinesPermanentGuidance,
    },
    {
      subHeading: 'Combinational Logic',
      chunk:
        'Each subroutine is assigned a priority, constraints, and a set of Conditions. The compliant subroutine with the highest priority is selected to be active, and optionally a default subroutine will become active if none are compliant. This is equivalent to the logic governing the deprecated OperationalModes, except that any subroutine can be set as the default (or there can be no default).',
    },
    {
      subHeading: 'Finite State Machine',
      chunk:
        'Each subroutine is a state of a finite state machine. Define the transitions between states based on conditions and priority.',
    },
    {
      subHeading: 'Schedule',
      chunk: 'Subroutines are scheduled, either using UTC or elapsed simulation time.',
    },
    {
      subHeading: '(Leaf) Routine',
      chunk: 'The generic Routine block can have no subroutines.',
    },
    {
      subHeading: 'Creating Routines',
      chunk: (
        <p>
          All existing Routines are visible in graph form in the routines widget. To create a new
          Routine, click the "Add Routines" button and drag a Routine of the desired type into the
          graph. Edit routines by double clicking on the nodes and clicking the edit button on edges
          of the graph. Routines can also be added by creating new edges between nodes. More
          information can be found in the{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://docs.sedaro.com/AgentBranch/cdh/routines"
            style={{ color: 'white' }}
          >
            Sedaro docs.
          </a>
        </p>
      ),
    },
  ],
};

export default routinesSegmentGuidance;
